import { useOutsideAlerter } from "hooks/outsiderAlerter";
import React, { useState } from "react";
import styled from "styled-components";

import { Col } from "./Containers";

type FloatDirection = "left" | "right";

interface Props extends React.PropsWithChildren {
  trigger: React.ReactNode;
  float?: FloatDirection;
}

export const Dropdown: React.FC<Props> = ({ children, trigger, float = "right" }) => {
  const wrapperRef = useOutsideAlerter(() => setVisible(false));
  const [visible, setVisible] = useState(false);

  return (
    <DropdownParent ref={wrapperRef}>
      <DropdownTrigger onClick={() => setVisible(!visible)}>{trigger}</DropdownTrigger>
      <OuterContainer onClick={() => setVisible(false)} float={float}>
        {visible && children}
      </OuterContainer>
    </DropdownParent>
  );
};

const OuterContainer = styled(Col)<{ float: FloatDirection }>`
  width: 200px;
  background-color: white;
  box-shadow: 0px 0px 6px 0px;
  border-radius: 8px;
  z-index: 1000;
  position: absolute;
  bottom: -5px;
  right: ${(props) => (props.float === "right" ? "0px" : "unset")};
  left: ${(props) => (props.float === "left" ? "0px" : "unset")};
  transform: translate(0%, 100%);
  overflow: hidden;
`;

const DropdownParent = styled.div`
  position: absolute;
`;

const DropdownTrigger = styled.div``;

export const DropdownButton = styled.button`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 5px;
  background-color: white;

  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;

  &:hover {
    filter: brightness(95%);
  }
  &:active {
    filter: brightness(99%);
  }
`;
